import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '../../styles';
export function Picture({ image: { url, title, width, height } }) {
    return url.endsWith('.svg') ? (React.createElement(Image, { src: url, alt: title, width: width, height: height, loading: "lazy" })) : (React.createElement("picture", null,
        React.createElement("source", { type: "image/webp", media: `(min-width: ${breakpoints.lg}px)`, srcSet: `${url}?w=${breakpoints.xl}&fm=webp` }),
        React.createElement("source", { media: `(min-width: ${breakpoints.lg}px)`, srcSet: `${url}?w=${breakpoints.xl}` }),
        React.createElement("source", { type: "image/webp", media: `(min-width: ${breakpoints.md}px)`, srcSet: `${url}?w=${breakpoints.lg}&fm=webp` }),
        React.createElement("source", { media: `(min-width: ${breakpoints.md}px)`, srcSet: `${url}?w=${breakpoints.lg}` }),
        React.createElement("source", { type: "image/webp", media: `(min-width: ${breakpoints.sm}px)`, srcSet: `${url}?w=${breakpoints.md}&fm=webp` }),
        React.createElement("source", { media: `(min-width: ${breakpoints.sm}px)`, srcSet: `${url}?w=${breakpoints.md}` }),
        React.createElement("source", { type: "image/webp", srcSet: `${url}?w=${breakpoints.sm}&fm=webp` }),
        React.createElement(Image, { src: `${url}?w=${breakpoints.sm}`, alt: title, width: width ? width / 2 : undefined, height: height ? height / 2 : undefined, loading: "lazy" })));
}
const Image = styled.img `
  max-width: 100%;
  height: auto;
`;
//# sourceMappingURL=Picture.js.map